// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.material-symbols-outlined {
  font-size: 14px;
}

.auth-wrapper {
  overflow: hidden;
}

.auth-panel {
  background: var(--surface-ground);
}

.auth-container {
  background: var(--exception-pages-image);
}

.body {
  padding-left: 0vw;
}
@media (min-width: 768px) {
  .body {
    padding-left: 10vw;
  }
}

.auth-body {
  min-width: 270px;
  max-width: 320px;
}

.logo-container {
  min-width: 270px;
  max-width: 320px;
}

.auth-title {
  font-size: 1.5rem;
  margin-top: 0;
}

.auth-link {
  font-weight: 500;
}
.auth-link:hover {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}
.auth-link.active {
  border-bottom: solid 2px #26CE7A;
  color: #26CE7A;
}
.auth-link.active:hover {
  border-bottom-color: inherit;
  color: inherit;
}

.footer {
  max-width: 800px;
  width: 100%;
  position: absolute;
  bottom: 0;
}

.free-trial-text {
  position: absolute;
  top: 50%;
  left: 30%;
  transform: translate(-50%, -50%);
  max-width: 320px;
  padding: 30px;
  color: white;
}
.free-trial-text .title {
  font-size: 36px;
}
.free-trial-text .subtitle {
  font-size: 25px;
}
.free-trial-text .content {
  font-size: 20px;
}
.free-trial-text .scan-img {
  width: 100%;
}
.free-trial-text .arrow {
  height: 2.5rem;
}
.free-trial-text .features {
  list-style-type: none;
  padding: 0;
  margin-top: 40px;
}
.free-trial-text .features ul {
  margin-top: 13px;
}
.free-trial-text .features .custom-icon {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 10px;
}
.free-trial-text .features .custom-text {
  font-size: 20px;
}
.free-trial-text .buttonPricing {
  display: inline-block;
  padding: 0.5rem;
  font-size: 20px;
  color: var(--primary-color);
  border-radius: 5px;
  text-decoration: none;
  background-color: white;
  margin-top: 20px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
  border: solid 2px transparent;
}
.free-trial-text .buttonPricing:hover {
  background-color: var(--primary-color);
  color: white;
  border: solid 2px white;
}`, "",{"version":3,"sources":["webpack://./src/app/main/pages/authentication/authentication.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAGA;EACI,iCAAA;AAAJ;;AAGA;EACI,wCAAA;AAAJ;;AAGA;EACI,iBAAA;AAAJ;AAEI;EAHJ;IAIQ,kBAAA;EACN;AACF;;AAEA;EACI,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,aAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;AACI;EACI,0BAAA;EACA,wBAAA;AACR;AAEI;EACI,gCAAA;EACA,cAAA;AAAR;AAEQ;EACI,4BAAA;EACA,cAAA;AAAZ;;AAKA;EACI,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AAFJ;;AAUA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAPJ;AASI;EACI,eAAA;AAPR;AAWI;EACI,eAAA;AATR;AAcI;EACI,eAAA;AAZR;AAeI;EACI,WAAA;AAbR;AAgBI;EACI,cAAA;AAdR;AAkBI;EACI,qBAAA;EACA,UAAA;EACA,gBAAA;AAhBR;AAkBQ;EACI,gBAAA;AAhBZ;AAmBQ;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;AAjBZ;AAoBQ;EACI,eAAA;AAlBZ;AAsBI;EACI,qBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,uDAAA;EACA,6BAAA;AApBR;AAwBI;EACI,sCAAA;EACA,YAAA;EACA,uBAAA;AAtBR","sourcesContent":[".material-symbols-outlined {\n    font-size: 14px;\n}\n\n.auth-wrapper {\n    overflow: hidden;\n\n}\n\n.auth-panel {\n    background: var(--surface-ground);\n}\n\n.auth-container {\n    background: var(--exception-pages-image);\n}\n\n.body {\n    padding-left: 0vw;\n\n    @media (min-width: 768px) {\n        padding-left: 10vw;\n    }\n}\n\n.auth-body {\n    min-width: 270px;\n    max-width: 320px;\n}\n\n.logo-container {\n    min-width: 270px;\n    max-width: 320px;\n}\n\n.auth-title {\n    font-size: 1.5rem;\n    margin-top: 0;\n}\n\n.auth-link {\n    font-weight: 500;\n\n    &:hover {\n        border-bottom-style: solid;\n        border-bottom-width: 2px;\n    }\n\n    &.active {\n        border-bottom: solid 2px #26CE7A;\n        color: #26CE7A;\n\n        &:hover {\n            border-bottom-color: inherit;\n            color: inherit;\n        }\n    }\n}\n\n.footer {\n    max-width: 800px;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n}\n\n// .auth-footer-brand {\n//     image-rendering: crisp-edges;\n//     image-rendering: -webkit-optimize-contrast;\n// }\n\n.free-trial-text {\n    position: absolute;\n    top: 50%;\n    left: 30%;\n    transform: translate(-50%, -50%);\n    max-width: 320px;\n    padding: 30px;\n    color: white;\n\n    .title {\n        font-size: 36px;\n    }\n\n\n    .subtitle {\n        font-size: 25px;\n    }\n\n\n\n    .content {\n        font-size: 20px;\n    }\n\n    .scan-img {\n        width: 100%;\n    }\n\n    .arrow {\n        height: 2.5rem;\n    }\n\n\n    .features {\n        list-style-type: none;\n        padding: 0;\n        margin-top: 40px;\n\n        ul {\n            margin-top: 13px\n        }\n\n        .custom-icon {\n            font-size: 40px;\n            font-weight: bold;\n            margin-bottom: 10px;\n        }\n\n        .custom-text {\n            font-size: 20px;\n        }\n    }\n\n    .buttonPricing {\n        display: inline-block;\n        padding: 0.5rem;\n        font-size: 20px;\n        color: var(--primary-color);\n        border-radius: 5px;\n        text-decoration: none;\n        background-color: white;\n        margin-top: 20px;\n        cursor: pointer;\n        transition: background-color 0.3s ease, color 0.3s ease;\n        border: solid 2px transparent;\n\n    }\n\n    .buttonPricing:hover {\n        background-color: var(--primary-color);\n        color: white;\n        border: solid 2px white;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
